import { SignOutButton, useUser } from "@clerk/clerk-react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/herba-logo.svg";
import { NAV_ITEMS, PAGES } from "../../constants/pages";
import NameCircle from "../nameCircle/NameCircle";

const LeftNav = () => {
  const { user } = useUser();
  const location = useLocation();

  return (
    <aside className="hidden md:block w-64 bg-blue-50 shadow-md">
      <div className="p-6 pt-9">
        <img src={logo} alt="Herba Logo" className="h-8 w-auto" />
      </div>
      <nav className="mt-4">
        {NAV_ITEMS.filter((navItem) => navItem.accessible(user)).map(
          (leftNavItem, idx) => (
            <Link
              key={idx}
              to={leftNavItem.href}
              className={`
                    flex items-center px-5 py-6 text-sm font-bold
                    ${
                      location.pathname === leftNavItem.href ||
                      (location.pathname === "/" &&
                        leftNavItem.href === PAGES.DASHBOARD)
                        ? "bg-blue-200 text-blue-600 border-l-8 border-blue-800"
                        : "text-blue-600 hover:bg-blue-200"
                    }
                `}
            >
              {leftNavItem.image} {leftNavItem.link}
            </Link>
          )
        )}
      </nav>
      <div className="absolute bottom-0 w-64 p-4">
        <div className="flex items-center">
          {user?.imageUrl && (
            <img
              src={user.imageUrl}
              alt="User Avatar"
              className="h-10 w-10 rounded-full mr-3"
            />
          )}
          {!user?.imageUrl && (
            <NameCircle
              name={user?.fullName || ""}
              index={0}
              greyScale={true}
            />
          )}
          <div>
            <p className="text-sm font-semibold text-grey-900 ">
              {user?.fullName || ""}
            </p>
            <SignOutButton>
              <span className="text-sm font-semibold text-blue-600 hover:underline cursor-pointer">
                Logout
              </span>
            </SignOutButton>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default LeftNav;
